/**
 * Style: (Content flow) Direction.
 */
export const enum Direction {

    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',

}
